import { clearEmailVerificationGateExemption } from '@/shared/lib/email-verification-gate-exemption';

import { getSignInUrl } from './get-api-url';

// The single funnel for every session termination the app can observe. The account app is a
// different origin, so navigating there leaves sessionStorage intact unless we clear it here.
export function signInUrlAfterEndingSession(withReturnUrl: boolean, returnUrl?: string): string {
    clearEmailVerificationGateExemption();
    return getSignInUrl(withReturnUrl, returnUrl);
}

export function redirectToSignIn(withReturnUrl: boolean, returnUrl?: string): void {
    window.location.href = signInUrlAfterEndingSession(withReturnUrl, returnUrl);
}
